import { render, staticRenderFns } from "./InvitationNotificationModal.vue?vue&type=template&id=072116bf&scoped=true&"
import script from "./InvitationNotificationModal.vue?vue&type=script&lang=js&"
export * from "./InvitationNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./InvitationNotificationModal.vue?vue&type=style&index=0&id=072116bf&prod&scoped=true&lang=css&"
import style1 from "./InvitationNotificationModal.vue?vue&type=style&index=1&id=072116bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072116bf",
  null
  
)

export default component.exports